import React, { useState, useEffect } from "react";
import axios from "axios";
import "../CSS/AppointmentTable.css";

const AppointmentTable = () => {
  const [appointments, setAppointments] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredAppointments, setFilteredAppointments] = useState([]);

  // Helper function to parse DD/MM/YYYY to MM/DD/YYYY
  const parseDate = (dateString) => {
    const [day, month, year] = dateString.split("/");
    return `${month}/${day}/${year}`; // Convert to MM/DD/YYYY
  };

  // Fetch data from the backend
  useEffect(() => {
    const fetchAppointments = async () => {
      try {
        const response = await axios.get("https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/getAppointments");
        const data = response.data;

        const formattedData = Object.entries(data)
          .map(([key, value], index) => ({
            id: key,
            sNo: index + 1,
            ...value,
            parsedDate: new Date(parseDate(value.Appointment_date)), // Parse date for sorting
          }))
          .sort((a, b) => b.parsedDate - a.parsedDate); // Sort by date in descending order

        setAppointments(formattedData);
        setFilteredAppointments(formattedData);
      } catch (error) {
        console.error("Error fetching appointments:", error);
      }
    };

    fetchAppointments();
  }, []);

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://us-central1-janushreebeautyparlour.cloudfunctions.net/api/deleteAppointment/${id}`);
      setAppointments((prev) => prev.filter((appointment) => appointment.id !== id));
      setFilteredAppointments((prev) =>
        prev.filter((appointment) => appointment.id !== id)
      );
    } catch (error) {
      console.error("Error deleting appointment:", error);
    }
  };

  const handleFilterChange = (e) => {
    const value = e.target.value.toLowerCase();
    setFilterText(value);

    const filtered = appointments.filter((appointment) => {
      return (
        appointment.Appointment_branch.toLowerCase().includes(value) ||
        appointment.Appointment_pnumber.includes(value) ||
        String(appointment.sNo).includes(value) ||
        appointment.Appointment_date.includes(value)
      );
    });
    setFilteredAppointments(filtered);
  };

  return (
    <>
      <div>
        <h2 className="p-4 text-center mb-4">Appointments</h2>

        <div style={{ marginBottom: "1rem", textAlign: "center" }}>
          <input
            type="text"
            placeholder="Filter by Branch, Phone Number, Date, or S.No"
            value={filterText}
            onChange={handleFilterChange}
            style={{
              padding: "0.5rem",
              width: "50%",
              fontSize: "1rem",
              border: "1px solid #ccc",
              borderRadius: "4px",
            }}
          />
        </div>

        {/* Add a scrollable container for the table */}
        <div style={{ overflowX: "auto", margin: "0 auto", width: "90%" }}>
          <table
            border="1"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              textAlign: "center",
            }}
          >
            <thead>
              <tr>
                <th>S.No</th>
                <th>Date</th>
                <th>Branch</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Phone Number</th>
                <th>Time</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {filteredAppointments.map((appointment) => (
                <tr key={appointment.id}>
                  <td>{appointment.sNo}</td>
                  <td>{appointment.Appointment_date}</td>
                  <td>{appointment.Appointment_branch}</td>
                  <td>{appointment.Appointment_fname}</td>
                  <td>{appointment.Appointment_lname}</td>
                  <td>{appointment.Appointment_pnumber}</td>
                  <td>{appointment.Appointment_time}</td>
                  <td>
                    <button onClick={() => handleDelete(appointment.id)}>Delete</button>
                  </td>
                </tr>
              ))}
              {filteredAppointments.length === 0 && (
                <tr>
                  <td colSpan="8" style={{ textAlign: "center" }}>
                    No appointments found
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </>
  );
};

export default AppointmentTable;
